module.exports = __webpack_public_path__ + "img/VAIANA2_20s.6617a9f3.jpg";